import { useEffect } from "react";
import { toast } from "react-toastify";

import { useCan } from "components";
import { KeyloopSubitemsModalQueryKeys } from "components/InterventionSubitemsModal/components/KeyloopSubitemsModal/queryKeys";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { ApiInstance } from "utils/Api";

type UseSearchInterventionElementsProps = {
  searchTerm: string;
  dealerLocationId: number;
};

export const useSearchInterventionElements = ({ searchTerm, dealerLocationId }: UseSearchInterventionElementsProps) => {
  const canSearchInterventionElements = useCan(ACL_ACTIVITIES.Search, ACL_RESOURCES.InterventionElementsCodes);

  const query = useTypedQuery({
    queryKey: KeyloopSubitemsModalQueryKeys.search,
    queryFn: async ({ endpoint, baseUrl }) =>
      (await ApiInstance.post(endpoint, { dealer_location_id: dealerLocationId, search_term: searchTerm }, baseUrl)).data.intervention_element_codes,
    enabled: canSearchInterventionElements
  });

  useEffect(() => {
    if (query.error) toast.error(query.error.message);
  }, [query.error]);

  return query;
};
